import { createReducer } from '@reduxjs/toolkit';
import groupBy from 'lodash/groupBy';
import mapValues from 'lodash/mapValues';
import omit from 'lodash/omit';
import remove from 'lodash/remove';

import {
  assignCreatives,
  deleteCreative,
  removeCreativeAssociation,
  removeCreativeAssociationFromProductsUsingCollectionIds,
} from '../../creative-assets/actions';
import { fetchCampaignLineCreatives } from '../actions';

export default createReducer(
  {},
  {
    [`${assignCreatives}-success`]: (
      state,
      { payload: campaignLineCreatives },
    ) => {
      campaignLineCreatives.forEach(campaignLineCreative => {
        const { campaignLineId } = campaignLineCreative;
        // eslint-disable-next-line no-param-reassign
        state[campaignLineId] = state[campaignLineId] || [];
        state[campaignLineId].push(campaignLineCreative);
      });
    },

    [`${removeCreativeAssociation}-success`]: (
      state,
      { payload: { campaignLineId, campaignLineCreativeId } },
    ) => {
      remove(
        state[campaignLineId],
        campaignLineCreative =>
          campaignLineCreative.id === campaignLineCreativeId,
      );
    },
    [`${removeCreativeAssociationFromProductsUsingCollectionIds}-success`]: (
      state,
      { payload: { lineIdsToClean } },
    ) => {
      return omit(state, lineIdsToClean);
    },
    [`${deleteCreative}-success`]: (state, { meta: { id } }) =>
      mapValues(state, assignments =>
        assignments.filter(assignment => assignment.creativeId !== id),
      ),
    [`${fetchCampaignLineCreatives}-success`]: (
      state,
      { payload: { campaignLineCreatives } },
    ) => groupBy(campaignLineCreatives, 'campaignLineId'),
  },
);
